
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './contacto1rmwxl.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pcontacto1rmwxl = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6772ee14df08e4838cb89b04" >

      <div id="iw4j" className="">
      
      <div id="i7iuy6" className="">
      
      <div id="ikooaf" className="">
      
      <span className="material-icons " id="iv5d9d">
        
      <span className="material-icons " id="iqcwn3">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="iwehdy">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijj06m">
        <>(+504) 9452-3409 </>
      </span>
      
      </div>
      
      <div className="" id="iws54s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9drhg">
        <>(+504) 3292-8788</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56xoug0.png"
        alt="undefined"
      />
      
      <div id="ifvvzp" className="">
      
      <a
        target=""
        className=""
        id="inedox"
        href="/"
        type="button"
      >
        
    <div id="iclrrs" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iacjt4"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ivmnu1" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
        <LoftyDropdownComponent
          id="ivtca1"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ivvbtj" className="gjs-dropdown-menu-trigger ">
<>Inmuebles</></div>

            </>
          }
          childrenHover={
            <>
              <div id="i837lj" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className="link-navbar "
          id="i5sny5"
          href={`/inmueblesenrenta`}
        >
          
    <div id="i3aqnf" className="">
    <>En Renta</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navbar "
          id="inb4q8"
          href={`/inmueblesenventa`}
        >
          
    <div id="izaae6" className="">
    <>En Venta</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
      <a
        target=""
        className=""
        id="ih0w28"
        href="/contacto"
        type="button"
      >
        
    <div id="i89xkj" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenrenta"
        type=""
      >
        <>Inmuebles en Renta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenventa"
        type=""
      >
        <>Inmuebles en Venta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icx7ut" className="">
      
      <div className="" id="ij68c3">
        <>Contáctanos</>
      </div>
      
      </div>
      
      <div id="ipvnvk" className="">
      
      <div className="" id="iol4ew">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="invi4p">
        <>Para obtener detalles de los productos y servicios puedes contactarnos al correo electrónico o por teléfono:</>
      </span>
      
      </div>
      
      <div id="ip8fff" className="">
      
      <div id="ikgzw4" className="">
      
      <div id="i4g711" className="">
      
      <div id="i2usyj" className="">
      
      <div className="" id="i8su8x">
        <>Correo electrónico</>
      </div>
      
      </div>
      
      <div className="" id="ipykjh">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="inbu7g">
        
      <a
        target=""
        className=""
        id="irwrl8"
        href="mailto:informacion@grupodor.com"
        type=""
      >
        <>informacion@grupodor.com</>
      </a>
      
      </span>
      
      </div>
      
      </div>
      
      <div id="im3e4d" className="">
      
      <div id="ioffdl" className="">
      
      <div className="" id="iyja8i">
        <>Teléfonos</>
      </div>
      
      </div>
      
      <div className="" id="igu50x">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ivxt2f">
        <>DOR +504 33445633</>
      <br className="" id="" />
      <>Rafael E. Orellana +504 98298911</>
      <br className="" id="" />
      <>José R. Orellana +504 94523409</>
      <br className="" id="" />
      <>Andrés E. Orellana +504 32928788 
María J. Orellana +504 33713711</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iw4c89" className="">
      
      <div id="iin6he" className="">
      
      <div className="" id="iik6mh">
        <>Dirección</>
      </div>
      
      </div>
      
      <iframe
        title="Mapa"
        className=""
        id="ic0wn6"
        frameBorder="0"
        src="https://maps.google.com/maps?&q=Tegucigalpa, Honduras&z=7&t=q&output=embed"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="il4d9o" className="">
      
      <div id="ioigc7" className="">
      
      <div id="ir2su1" className="">
      
      <img
        className=""
        id="imr6xn"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z3fz2.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iip0hj" className="">
      
      <div id="icdzzf" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contacto"
        type="button"
      >
        
    <div id="isq53" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="inxorr" className="">
      
      <img
        className=""
        id="iib493"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z589z.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i9jwhn">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ilrddl">
        <>Teléfono: +504 33445633 
Correo electrónico: informacion@grupodor.com 
Dirección: </>
      </span>
      
      <span className="" id="iteqkj">
        <>Colonia Universidad, 24 calle, 9 avenida, Plaza Bulevares, San Pedro Sula, Cortés, Honduras C.A.</>
      </span>
      
      </div>
      
      <div id="ikrieu" className="">
      
        <a
          target="_blank"
          className=""
          id="iugvxb"
          href="https://www.facebook.com/DORInmobiliariaHN/?_rdr"
        >
          
      <span className="" id="ifk2kr">
        <>Facebook</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="iewo54"
          href="https://www.instagram.com/dorinmobiliaria"
        >
          
      <span className="" id="ig11q1">
        <>Instagram</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ixgr5i"
          href="https://www.linkedin.com/company/dor-inmobiliaria/"
        >
          
      <span className="" id="iz2xzh">
        <>LinkedIn</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="imier2" className="">
      
      <div id="i50ldy" className="">
      
      </div>
      
      <div id="igphyo" className="">
      
      <div className="" id="i1gmf4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iy1e52">
        <>DOR © 2024. Todos los derechos reservados</>
      </span>
      
      </div>
      
      <div className="" id="ids74n">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="izx0i8">
        <>Términos de uso</>
      </span>
      
      </div>
      
      <div className="" id="i6pgi9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itfy23">
        <>Políticas de privaciad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontacto1rmwxl);
  